import React from 'react';
import editMinutes from './editMinutes';
import BeforeOrAfter from './BeforeOrAfter';
import Card from './Card';

class BeforeOrAfterContainer extends React.Component {
 state = {
   before: false,
   after: false,
 };
 componentWillMount() {
   if (this.props.beforeOrAfter !== undefined) {
     if (this.props.beforeOrAfter === 'after') {
       this.setState({ after: true });
     }
     if (this.props.beforeOrAfter === 'before') {
       this.setState({ before: true });
     }
   }
 }

 componentWillReceiveProps(nextProps) {

   if (nextProps.masterData !== this.props.masterData ||
     nextProps.duration !== this.props.duration ||
    nextProps.product !== this.props.product) {
     const { masterData, duration } = nextProps;
     if (masterData === undefined) { return; }
     if (masterData || duration) {
       this.changeTime(nextProps);
     }
   }
 }


 componentWillUnmount() {
   const { before, after } = this.state;

   if (before) {
     this.props.handleBeforeOrAfter('before');
   }
   if (after) {
     this.props.handleBeforeOrAfter('after');
   }
 }

 setStatus = (button) => {
   if (button === 'before') {
     // Om man klickar på before och den är aktiv ska den bli tvärtom
     this.setState(prevState => ({
       before: !prevState.before,
       after: false,
     }), this.changeTime);
     // Därefter ska
   }

   if (button === 'after') {
     // Om man klickar på before och den är aktiv ska den bli tvärtom
     this.setState(prevState => ({
       after: !prevState.after,
       before: false,
     }), this.changeTime);
   }
 };

 changeTime = (status = this.props) => {
   const { masterData, duration } = status;


   if (this.state.before) {
     this.props.onClickSchedule({
       date: masterData.date.date,
       start: editMinutes(masterData.date.start, duration, true),
       end: masterData.date.start,
     });
   }
   if (this.state.after) {
     this.props.onClickSchedule({
       date: masterData.date.date,
       start: masterData.date.end,
       end: editMinutes(masterData.date.end, duration),
     });
   }
 };

 render() {
   const {
     masterData, duration, onClickSchedule, bookingData,
   } = this.props;
   const { before } = this.state;


   if (masterData === undefined) { return null; }



   return (
     <div>
       <Card title="Välj tid">
         <div className="row is-flex">

           <BeforeOrAfter
             name="Innan"
             date={editMinutes(masterData.date.start, duration, true) + '-' + masterData.date.start}
             clicked={this.state.before}
             onClick={() => this.setStatus('before')}
           />

           <BeforeOrAfter
             name="Efter"
             date={masterData.date.end + '-' + editMinutes(masterData.date.end, duration)}
             clicked={this.state.after}
             onClick={() => this.setStatus('after')}
           />

         </div>
       </Card>
     </div>
   );
 }
}

export default BeforeOrAfterContainer;



// WEBPACK FOOTER //
// ./src/components/Resource/components/BeforeOrAfterContainer.jsx